const getEnv = (name: string, defaultValue?: string): string | undefined => {
  if (typeof window === 'undefined') {
    return process.env[name] || defaultValue
  }
  return window.__REACT_ENV__[name] || process.env[name] || defaultValue
}

export default getEnv
